import { HStack, IconButton, Tooltip } from '@elkaso-app/web-design';
import { useCallback } from 'react';
import { FiEye, FiTrash2 } from 'react-icons/fi';

export interface IActionsCell {
  scanId: number;
  onView: (scanId: number) => void;
  onDelete: (scanId: number) => void;
}

export const ActionsCell = ({ scanId, onView, onDelete }: IActionsCell) => {
  const handleView = useCallback(() => onView(scanId), [onView, scanId]);
  const handleDelete = useCallback(() => onDelete(scanId), [onDelete, scanId]);

  return (
    <HStack spacing={1}>
      <Tooltip label='View Details' placement='top'>
        <IconButton aria-label='View details' icon={<FiEye />} size='sm' variant='ghost' colorScheme='blue' onClick={handleView} />
      </Tooltip>
      <Tooltip label='Delete' placement='top'>
        <IconButton aria-label='Delete scan' icon={<FiTrash2 />} size='sm' variant='ghost' colorScheme='red' onClick={handleDelete} />
      </Tooltip>
    </HStack>
  );
};
